import { render, staticRenderFns } from "./CustomerUsers.vue?vue&type=template&id=d31540c6&scoped=true&"
import script from "./CustomerUsers.vue?vue&type=script&lang=js&"
export * from "./CustomerUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31540c6",
  null
  
)

export default component.exports